import { jsx } from 'react/jsx-runtime';
import { convertUrlToSpotifyEmbedUrl } from '../../expandedResource.utils.js';

const SpotifyEmbed = ({ url, children }) => {
  const embedUrl = convertUrlToSpotifyEmbedUrl(url);
  if (!embedUrl) {
    return children;
  }
  return /* @__PURE__ */ jsx("iframe", {
    style: {
      borderRadius: 12
    },
    src: embedUrl,
    width: "100%",
    height: "352",
    frameBorder: "0",
    allowFullScreen: true,
    allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
    loading: "lazy"
  });
};

export { SpotifyEmbed };
//# sourceMappingURL=SpotifyEmbed.js.map
